export default __webpack_public_path__ + "static/media/plus.673dd83b.svg";